import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {lastValueFrom, Observable} from 'rxjs';
import {PdfDto} from "../model/pdf-dto";

export enum CSCProviders {
    "S8" = "s8",

}

@Injectable({
    providedIn: 'root',
})
export class CscSignDocService {
    private baseUrl = '/api/sipo/providers'; // Backend Base URL

    constructor(private http: HttpClient) {
    }

    // getAuthorizceUrl(type: CSCProviders, docId: string): Observable<string> {
    //     //type = CSCProviders.S8;
    //     return this.http.get(`${this.baseUrl}/${type}/signdocs/authorize/${docId}`, {responseType: 'text'});
    // }
    //
    // getAuthorizceUrlPromise(type: CSCProviders, docId: string): Promise<string> {
    //     type = CSCProviders.S8;
    //     return lastValueFrom(this.getAuthorizceUrl(type, docId));
    // }




    postSignDoc(subItemId: string, credentialID: string, credential_access_token: string): Observable<any> {
        const payload = {
            docId: subItemId,
            credentialID: credentialID,
            credential_access_token: credential_access_token,
        }

        return this.http.post("/api/sipo/providers/signdocs", payload, {
            responseType: 'blob' as 'json'  // 👈 wichtig!
        });
    }

    putSignResult(docId: string, state: string): Observable<any> {

        const formData: FormData = new FormData();
        formData.append('state', state);

        return this.http.put("/api/sipo/states/"+docId, formData);
    }




    // getAccessToken() {
    //     return this.http.post(`${this.baseUrl}/access_token/url`, null, {responseType: 'text'});
    // }
    //
    // signDoc() {
    //
    // }

    // postSignPolling(requestId: string, provider: string, credential_access_token: string): Observable<any> {
    //     const payload = {
    //         requestId: requestId,
    //         credential_access_token: credential_access_token,
    //     }
    //
    //     return this.http.post(`${this.baseUrl}/${provider}/signpolling`, payload);
    // }
}
